
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import { NewIssueComment } from "@/types/issue";
import {
  getIssue,
  createIssueComment,
  downloadTareaImagen,
} from "@/actions/issue";
import { saveAs } from "file-saver";
import { readFile } from "@/utils";

export default Vue.extend({
  name: "IssueView",
  created() {
    this.loadIssue();
  },
  methods: {
    loadIssue(moveScrollToBottom: false) {
      this.isLoading = true;
      getIssue(this.$route.params.id)
        .then((issue) => {
          this.issue = issue;
        })
        .finally(() => {
          this.isLoading = false;
          if (moveScrollToBottom) {
            this.moveScrollToBottom();
          }
        });
    },
    moveScrollToBottom() {
      this.$nextTick(() => {
        const endCommentElement = document.getElementById("end-comments");
        if (endCommentElement) {
          endCommentElement.scrollIntoView();
        }
      });
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    getFormattedDate(date: string) {
      return moment(date).fromNow();
    },
    async downloadImage(id: string, name: string) {
      const binary = await downloadTareaImagen(id, this.issue.id);
      saveAs(binary as string, name);
    },
    async handleSubmit() {
      if (!this.form.description) return;

      const adjuntos = [];
      for (let i = 0; i < this.form.files.length; i++) {
        adjuntos.push(await this.createAdjuntoFormat(this.form.files[i]));
      }

      const dateMoment = moment();
      const newIssueComment: NewIssueComment = {
        comentario: this.form.description,
        fecha: {
          date: {
            year: +dateMoment.format("YYYY"),
            month: +dateMoment.format("MM"),
            day: +dateMoment.format("DD"),
          },
          time: {
            hour: +dateMoment.format("HH"),
            minute: +dateMoment.format("mm"),
          },
        },
        adjuntos,
      };

      createIssueComment(this.issue.id, newIssueComment).then(() =>
        this.loadIssue(true)
      );
    },
    async createAdjuntoFormat(file: any) {
      const fileContents = await readFile(file);
      const splitB64 = fileContents.toString().split(",");
      return {
        id: null,
        fileAdjunto: splitB64[1],
        nombre: file.name,
        adjuntoTipoId: 1,
      };
    },
    previewFiles(event) {
      this.form.files = event.target.files;
    },
  },
  computed: {
    ...mapGetters({
      state: "getState",
    }),
  },
  data() {
    return {
      isLoading: true,
      issue: null,
      form: { description: "", files: [] },
      formState: { description: null },
    };
  },
});
